<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-dialog v-model="dialog" scrollable width="800px" style="z-index: 999999999">
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <span>{{ description }}</span><br>

          </v-col>
          <v-col cols="12" class="justify-center">
            <center>
            <v-hover
                v-slot:default="{ hover }"
                open-delay="200"
            >
              <v-card
                  :color="hover ? 'lightgrey' : undefined"
                  max-width="350"
                  width="350"
                  class="ma-2"
                  flat
              >
                <center v-if="hover" ><video :src="getVideoUrl(customData.item)" ref="player" autoplay style="max-width: 350px;padding:0px;max-height: 190px;height: 190px;margin: 0px;"></video></center>
                <v-img v-else :src="tableUtils.getImage(customData.item)" :lazy-src="tableUtils.getImageThumbUrl(customData.item)" contain alt="Thumbnail" max-height="197"></v-img>
                <div style="width: 350px;height:22px; background-color: lightgray" :title="customData.item.localFileName">
                  <span style="width:200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: bold" class="ml-2">{{customData.item.title}}</span>
                  <span style="float: right"> {{customData.item.duration}} Sek. <v-icon small class="pa-0 nt-0 mr-2">mdi-timelapse</v-icon></span>
                </div>
              </v-card>
            </v-hover>
            </center>
          </v-col>

          <v-col cols="6" class="py-0">
            <v-flex xs12 style="max-width: 180px">
              Aktiv von
              <v-datetime-picker @input="setDT" v-model="formattedDatetime" date-format="dd.MM.yyyy" timeFormat="HH:mm"></v-datetime-picker>
            </v-flex>

          </v-col>
          <v-col cols="6" class="py-0">
            <v-flex xs12 style="max-width: 180px">
              Aktiv bis
              <!--<v-text-field v-model="formattedDatetimeTill"></v-text-field>-->
              <v-datetime-picker @input="setDT" v-model="formattedDatetimeTill" date-format="dd.MM.yyyy" timeFormat="HH:mm">
              </v-datetime-picker>
            </v-flex>
          </v-col>
          <v-col cols="12">
            <v-card>

              <v-data-table
              :headers="headers"
              :items="deviceList"
              show-select
              hide-default-footer
              hide-details
              :items-per-page="-1"
              v-model="selected"
              :search="search"
              >
                <template v-slot:item.name="{ item }">
                  <span class="handpointer" @click="select(item)">{{item.name}}</span>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doSave()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Zuweisen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import tableUtils from "@/components/tables/TableUtils";
import Vue from "vue";
import moment from "moment";

export default {
  name: 'DialogShareMediaItem',
  computed: {
    tableUtils() {
      return tableUtils
    }
  },
  components: {},
  methods: {
    /**
     * newName, title, type
     * @param cardConfig
     */
    doCancel: function () {
      this.dialog = false
      this.$emit('cancel', null)
    },
    doSave: function () {
      this.dialog = false
      this.formattedDatetime = moment(this.formattedDatetime, "DD.MM.YYYY HH:mm").toDate()
      this.formattedDatetimeTill = moment(this.formattedDatetimeTill, "DD.MM.YYYY HH:mm").toDate()
      this.customData.item.activeFrom = this.formattedDatetime.getTime()
      this.customData.item.activeTill = this.formattedDatetimeTill.getTime()

      this.formattedDatetime = moment(this.customData.item.activeFrom).format("DD.MM.YYYY HH:mm")
      this.formattedDatetimeTill = moment(this.customData.item.activeTill).format("DD.MM.YYYY HH:mm")
      this.$emit('save', {
        customData: this.customData,
        selected: this.selected
      })
    },
    select: function (item) {
      console.log('onSelect', item)
    },
    getVideoUrl: function(item) {
      return Vue.prototype.$api.getVideoUrl(item)
    },
    open: function (cardConfig, deviceList, guidSelected, customData) {
      this.selected = []
      this.deviceList = deviceList
      this.customData = customData

      for (let i in this.deviceList) {
        let d = this.deviceList[i]
        if (d.guid === guidSelected) {
          this.selected.push(d)
        }
      }

      if ((cardConfig != null) && (cardConfig)) {
        this.title = cardConfig.title
        this.description = cardConfig.description
      }

      if (customData.item.activeFrom === null || customData.item.activeFrom === 0 ) {
        customData.item.activeFrom = new Date().getTime()
      }
      if (customData.item.activeTill === null || customData.item.activeTill === 0 ) {
        let d = new Date()
        d.setFullYear(d.getFullYear() + 1)
        customData.item.activeTill = d.getTime()
      }
      this.activeFrom = new Date(customData.item.activeFrom)
      this.activeTill = new Date(customData.item.activeTill)

      this.formattedDatetime = moment(this.activeFrom).format("DD.MM.YYYY HH:mm")
      this.formattedDatetimeTill = moment(this.activeTill).format("DD.MM.YYYY HH:mm")

      this.dialog = true

    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    setDT: function() {

    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {
      activeFrom: new Date().getTime(),
      activeTill: new Date().getTime(),
      formattedDatetime: '01.09.2019 12:00',
      formattedDatetimeTill: '01.09.2019 13:00',
      customData: null,
      selected: [],
      headers: [
        {text: 'Name', align: 'left', value: 'name'}
      ],
      search: '',
      deviceList: [],
      title: 'Login nicht erfolgreich',
      description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
      dialog: false
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
